import { Directive, HostListener } from '@angular/core';
import { MAT_INPUT_VALUE_ACCESSOR } from '@angular/material/input';

/**
 * uppercase directive provides a convenient way to trigger
 * character capitalization of an input field value
 *
 * input value will get capitalized when `uppercase` property is set.
 */
@Directive({
    selector: '[uppercase]',
    standalone: true,
    providers: [
        {
            provide: MAT_INPUT_VALUE_ACCESSOR,
            useExisting: UppercaseDirective
        }
    ]
})
export class UppercaseDirective {
    @HostListener('input', ['$event']) onInput(event: KeyboardEvent) {
        const input = event.target as HTMLInputElement;
        input.value = input.value.toUpperCase();
    }
}
